module.exports = __webpack_public_path__ + "static/j-9b30d5d1113b86984db0a385284597dd.jpg";